import NavMenu from '../section/LoggedInNav.js';
import SITELINKS from '../section/Footer.js';
import Banner from '../section/Title.js';
import resetPassword from '../images/resetPassword.png';
import filterPayments from '../images/filterPayments.png';
import exportPayments from '../images/exportPayments.png';
import registerAccount from '../images/registerAccount.png';
import Button from 'react-bootstrap/Button';
import AdditionalHelp from '../section/AdditionalHelp.js';

import React, { useState } from 'react';

//boostrap components 
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export const FaqPage = () => {
  const [emailPopup, setEmailPopup] = useState({
    open: false,
    email: '',
    subject: '',
    title: ''
  });

  const openEmailPopup = (email, subject, title) => {
    setEmailPopup({ open: true, email, subject, title });
  };

  const closeEmailPopup = () => {
    setEmailPopup({ open: false, email: '', subject: '', title: '' });
  };

  const handleCopyEmail = async () => {
    try {
      await navigator.clipboard.writeText(emailPopup.email);
    } catch (err) {
      window.prompt('Copy email address:', emailPopup.email);
    }
  };

  const mailtoHref = emailPopup.email
    ? `mailto:${emailPopup.email}?subject=${encodeURIComponent(emailPopup.subject || '')}`
    : '#';

  return (
    <div className='App'>

      <div className='hidden'>
        <Banner/>
      </div>        
      <NavMenu/> 
      <Banner/>
      
      <Container className='App'>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12}>
            <div className='App empBorder padding text-center'>
              <h1 className='text-center emphTitle'>FAQ Page</h1>
              <p className=' '>
                <i>Page Updated 01/29/2026</i>
              </p>
              <br></br><hr></hr>
              <h4 className='emphTitle text-center'> How do I create an account?</h4>
              <p className='  '>Please Navigate to the Portal Dashboard and select Create Account / Register Account. 
                You can also visit the webpage here:   
                <a className='btn btn-primary' href='/register'>Register</a>
              </p>
            
             <img src={registerAccount} className='mLogo' alt="mhb-site-logo.png" />

              <ol className='text-center padding'>
                <p>Enter your Metro Housing Boston Affiliated Email Address. If you do not know this, please check our FAQ pag for more information</p>
                <p>Please confirm your account by entering the PIN that is sent to your MHB affiliated email that was used in the first step</p>
                <p>Once Logged in, please click on the Payments link to navigate and view all MHB Payments for your properties</p>
              </ol>
              
              <br></br>

              {emailPopup.open && (
                <div
                  className="modal d-block"
                  tabIndex="-1"
                  role="dialog"
                  style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
                >
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">{emailPopup.title}</h5>
                        <button
                          type="button"
                          className="btn-close"
                          aria-label="Close"
                          onClick={closeEmailPopup}
                        />
                      </div>
                      <div className="modal-body">
                        <p>Email: <strong>{emailPopup.email}</strong></p>
                        <button
                          type="button"
                          className="btn btn-outline-secondary me-2"
                          onClick={handleCopyEmail}
                        >
                          Copy Email
                        </button>
                        <a className="btn btn-primary" href={mailtoHref}>
                          Send Email
                        </a>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={closeEmailPopup}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <br></br>
              <hr></hr>

              <h4 className='emphTitle text-center'>Need Help With Payments or Account Data?</h4>
              <p className='  '>
                <b>Use Portal Help for any of the following:</b>
                <ul className='text-start text-center'>
                  <br></br>
                  <p>Unable to view payments</p>
                  <p>Incorrect data submitted when your account was created</p>
                  <p>Duplicate payment data shown on the Payments page</p>
                </ul>
              </p>
              <p className='  '>
                Please file a request with{' '}
                <button
                  type="button"
                  className='btn btn-primary'
                  onClick={() =>
                    openEmailPopup(
                      'portalhelp@mbhp.org',
                      '[Portal Support]',
                      'Contact Portal Help'
                    )
                  }
                >
                  Portal Help / Technical Support
                </button>{' '}
                and include your details.
              </p>
              <br></br>
              <hr></hr>

              {/* Removed:
                - Incorrect data submitted when account was created?
                - Duplicate Payment Data shown on Payments Page?
              */}

              <h4 className='emphTitle text-center'>Update my Direct Deposit Information</h4>
              <p className='  '>
                Please contact OwnerServices@metrohousingboston.org{' '}
                    <Button
                        variant='primary'
                        size='sm'
                        className='w-25 nav-square-button mx-auto additional-help-button'
                        target='_blank'
                        href='https://www.metrohousingboston.org/wp-content/uploads/2019/08/Direct-Deposit-Form-update-8.12.19-fillable-1.pdf'
                    >
                        Update Direct Deposit Form
                    </Button>
              </p>
              <br></br>
              <hr></hr>

              <h4 className='emphTitle text-center'> Update Rent-Share</h4>
              <p className='  '>
                Please contact OwnerServices@metrohousingboston.org{' '}
                <button
                  type="button"
                  className='btn btn-primary'
                  onClick={() =>
                    openEmailPopup(
                      'OwnerServices@metrohousingboston.org',
                      '[Rent-Share Update]',
                      'Contact Owner Services'
                    )
                  }
                >
                  Owner Services
                </button>
              </p>
              <br></br>
              <hr></hr>


              <h4 className='emphTitle text-center'> Filter and sort payments?</h4>
              <p className='  '>Please navigate to the Payments page. On the right-hand side of the payments database table, select the Date Range tab and choose the timeframe you wish to review. You may select from predefined options such as the last 7 days or 30 days, or specify a custom range if you need to generate a report covering multiple years of remittance activity.</p>
              <img src={filterPayments} className='mLogo' alt="mhb-site-logo.png" />
              <br></br>
              <hr></hr>

              <h4 className='emphTitle text-center'> Export payments?</h4>
              <p className='  '>Please navigate to the Payments page. Begin by selecting the desired payment range using the filter section outlined above. Once the relevant payments are displayed, click the Export button and choose the appropriate option—S8, MRVP, HAPPY, or WSD payments. You may also choose to export all database tables into a single XLSX file.</p>
              <img src={exportPayments} className='mLogo' alt="mhb-site-logo.png" />
              <br></br>
              <hr></hr>

              <h4 className='emphTitle text-center'> Reset Password?</h4>
              <p className='  '>Please reset your password by clicking on the Forgot Your Password Link Illustrated below. You can find this on the Home, Registration, or Login Page.  </p>
              <p>Login Page URL: <a href="https://mhbportal.org/login">https://mhbportal.org/login</a></p>
              <img src={resetPassword} className='mLogo' alt="mhb-site-logo.png" />
              <br></br>
              <hr></hr>

              <h4 className='emphTitle text-center'> Submit Feedback on the Portal</h4>
              <p className='  '>Click here to get started: <a className='btn btn-primary' target='_blank' rel='noreferrer' href="https://forms.office.com/Pages/ResponsePage.aspx?id=J8xXIgxdK0y6AnOQOwjqAHVPPCEmmcRLu9IABP8zZRBUQlFDU0RFQUxRRjdCTzY4NTZQWjVMS09SVC4u">MHB Portal Feedback Form</a> </p>
              <br></br>
              <hr></hr>
              <AdditionalHelp/>

            </div>
          </Col>
        </Row>
      </Container>  
      <SITELINKS/> 
    </div>
  );
};